import type { SchoolDto } from './SchoolDto'
import type { TicketMessageDto } from './TicketMessageDto'
import type { UserDto } from './UserDto'

export const ticketDtoStatusEnum = {
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
  '5': 5,
  '10': 10,
  '20': 20,
  '30': 30,
} as const

export type TicketDtoStatusEnum = (typeof ticketDtoStatusEnum)[keyof typeof ticketDtoStatusEnum]

export const ticketDtoRedirectToEnum = {
  '1': 1,
  '2': 2,
} as const

export type TicketDtoRedirectToEnum = (typeof ticketDtoRedirectToEnum)[keyof typeof ticketDtoRedirectToEnum]

export type TicketDto = {
  /**
   * @type number
   */
  status: TicketDtoStatusEnum
  /**
   * @type number
   */
  redirect_to?: TicketDtoRedirectToEnum | null
  /**
   * @type array
   */
  messages: TicketMessageDto[]
  /**
   * @type number
   */
  id: number
  /**
   * @type number
   */
  user_id: number
  user: UserDto | null
  /**
   * @type number
   */
  manager_id: number
  manager: UserDto | null
  /**
   * @type string
   */
  title: string
  /**
   * @type number
   */
  school_id?: number | null
  school?: SchoolDto | null
  /**
   * @type number
   */
  incoming_id: number | null
  /**
   * @type string, date-time
   */
  created_at: string
  /**
   * @type string, date-time
   */
  updated_at: string
  /**
   * @type string, date-time
   */
  closed_at: string | null
}